import { FIREBASE_DEPRECATION_TOOLTIP_CONTENT } from 'modules/mobileApps/constants';
import { useIntegrationMetadataContext } from 'modules/mobileApps/context/integrationMetadata';
import { selectIntegrations } from 'modules/mobileApps/selectors';
import { getIsLegacyFirebaseIntegration } from 'modules/mobileApps/utils';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { AppCard } from 'ui/card/AppCard';
import { colors, spacing } from 'ui/theme';
import { AppIcon } from '../AppIcon';
import {
  MobileAppList,
  MobileAppName,
  PackageName,
  StyledTooltip,
  StyledWarningBadge,
} from './styles';

export const AppList = () => {
  const integrations = useSelector(selectIntegrations);

  const history = useHistory();
  const directToDetailsPage = ({ id }: { id: number }) =>
    history.push(`/integrations/mobileApps/${id}`);

  const { apps } = useIntegrationMetadataContext();

  const legacyFirebaseIntegrations = integrations.filter(({ platform, authType }) =>
    getIsLegacyFirebaseIntegration(platform, authType),
  );

  const doesAppNeedUpdate = (appId: number) =>
    legacyFirebaseIntegrations.some((i) => i.mobileAppId === appId);

  return (
    <MobileAppList>
      {apps.map(({ name, platform, id, packageName }) => (
        <AppCard key={id} onClick={() => directToDetailsPage({ id })}>
          {doesAppNeedUpdate(id) && (
            <StyledTooltip tooltipContent={FIREBASE_DEPRECATION_TOOLTIP_CONTENT}>
              <StyledWarningBadge data-test="app-list-update-warning-badge">
                Update
              </StyledWarningBadge>
            </StyledTooltip>
          )}
          <AppIcon
            color={colors.iconPrimary}
            height={spacing.double}
            platformType={platform}
            width={spacing.double}
          />
          <MobileAppName>{name}</MobileAppName>
          <PackageName>{packageName}</PackageName>
        </AppCard>
      ))}
    </MobileAppList>
  );
};
